/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class DetailModel {
    public Id: string;

    constructor(DetailForm: any) {
      this.Id = DetailForm.Id || '';
    }
  }
